import { render, staticRenderFns } from "./TaskProposedTasksGroups.vue?vue&type=template&id=ffff697a&scoped=true&"
import script from "./TaskProposedTasksGroups.vue?vue&type=script&lang=js&"
export * from "./TaskProposedTasksGroups.vue?vue&type=script&lang=js&"
import style0 from "./TaskProposedTasksGroups.vue?vue&type=style&index=0&id=ffff697a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffff697a",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QItem,QItemSection,QItemLabel,QScrollArea,QSeparator,QCardActions,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign({QDialog,QCard,QCardSection,QItem,QItemSection,QItemLabel,QScrollArea,QSeparator,QCardActions,QBtn}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
